import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <div className="inline-flex items-center gap-2.5 rounded-full border border-[var(--border-subtle)] px-4 py-1.5 mb-6">
    <span className="h-1.5 w-1.5 rounded-full" style={{ background: "var(--accent-primary)" }} />
    <span className="font-heading text-xs font-semibold uppercase tracking-[0.18em] text-[var(--text-secondary)]">
      {children}
    </span>
  </div>
);
